Shopify.Products.recordRecentlyViewed();

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', {
      bubbles: true
    })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': `application/${type}`
    }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};


Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    const closeBtn = this.querySelector('[id^="ModalClose-"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });

    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        ) {
          this.hide();
        }
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal || !this.sliderLastItem) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }


  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  resetSlider() {
    // Temporarily disable smooth scrolling if it's applied via CSS
    const originalScrollBehavior = this.slider.style.scrollBehavior;
    this.slider.style.scrollBehavior = 'auto';

    // Reset scroll position to the start immediately
    this.slider.scrollLeft = 0;

    // Update the slider state so the counter and buttons reflect the first slide
    this.update();

    // Restore original scroll behavior
    this.slider.style.scrollBehavior = originalScrollBehavior;
  }

}

customElements.define('slider-component', SliderComponent);

let themeVarId = '';

class VariantSelects extends HTMLElement {

  static PREF_KEY = 'laa_pickup_prefs';

  // 2) call this to save the user’s last‐chosen method & location
  savePreferences(method, location) {
    localStorage.setItem(
      VariantSelects.PREF_KEY,
      JSON.stringify({ method, location })
    );
  }

  // 3) call this to load their prefs (returns {method,location})
  loadPreferences() {
    try {
      return JSON.parse(localStorage.getItem(VariantSelects.PREF_KEY)) || {};
    } catch {
      return {};
    }
  }


  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.productUrl = this.dataset.url;
    this.productJson = null;
    this.currentVariant = null;
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  connectedCallback() {
    // Run once on load so default picks apply
    requestAnimationFrame(() => this.onVariantChange());
  }

  // ─── Fetch + cache full product JSON (for sale-dot logic) ─────────
  ensureProductJson() {
    //console.log(this.productJson);
    if (this.productJson) return Promise.resolve(this.productJson);
    return fetch(`${this.productUrl}.js`)
      .then(r => r.json())
      .then(json => (this.productJson = json));
  }


  onVariantChange() {
    // 1) Optional: client-side image filter
    //this.updateMedia?.();

    const picks = Array.from(
      this.querySelectorAll('input[type="radio"]:checked'),
      i => i.dataset.optionValueId
    ).filter(Boolean);
    const url = new URL(window.location.href);
    url.searchParams.set('option_values', picks.join(','));
    history.replaceState({}, '', url);

    // 3) Fetch Shopify’s server-rendered section
    const params = new URLSearchParams({
      section_id: this.sectionId,
      option_values: picks.join(',')
    });

    fetch(`${this.productUrl}?${params.toString()}`)
      .then(r => {
        if (!r.ok) throw new Error(r.statusText);
        return r.text();
      })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');


        const priceId = `price-${this.sectionId}`;
        const newPrice = doc.getElementById(priceId);
        const currentPrice = document.getElementById(priceId);
        if (newPrice && currentPrice) {
          currentPrice.innerHTML = newPrice.innerHTML;
          currentPrice.classList.remove('visibility-hidden');
        }

        const formId = `product-form-${this.sectionId}`;
        const newForm = doc.getElementById(formId);
        const currentForm = document.getElementById(formId);
        if (newForm && currentForm) {
          currentForm.innerHTML = newForm.innerHTML;
        }




        const newPicker = doc.querySelector('variant-selects');
        if (newPicker) {
          this.innerHTML = newPicker.innerHTML;
          // re-bind our change listeners
          this.querySelectorAll('input[type="radio"]').forEach(input =>
            input.addEventListener('change', this.onVariantChange.bind(this))
          );

        }


        this.applySaleDots();



        // ─── LOG SIZE OPTIONS FOR SELECTED COLOR ─────────────────────
        this.ensureProductJson().then(product => {
          // 1) Find the checked colour radio (starts-with selector handles your “Color-1\n” name)
          const colorInput = this.querySelector('input[type="radio"][name^="Color"]:checked');
          if (!colorInput) return;
          const selColor = colorInput.value.trim();

          // 2) Filter down to variants of that colour
          const variants = product.variants.filter(v => v.options[0] === selColor);

          // 3) Pull out sizes and group by availability
          const allSizes = [...new Set(variants.map(v => v.options[1]))];
          const available = [...new Set(
            variants.filter(v => v.available).map(v => v.options[1])
          )];
          const soldOut = [...new Set(
            variants.filter(v => !v.available).map(v => v.options[1])
          )];

          // 4) Console the results
          //console.log('Color:', selColor);
          //console.log('All sizes for this color:',  allSizes);
          //console.log('→ Available sizes:',     available);
          // console.log('→ Sold-out sizes:',      soldOut);
        });
        // ───────────────────────────────────────────────────────────────

        const script = doc.querySelector('script[data-selected-variant]');
        const raw = script?.textContent.trim();

        // 1) Invalid / nonexistent combo → “Unavailable”
        if (!raw || raw === 'null') {
          // load full JSON
          this.ensureProductJson().then(product => {
            // a) which color is checked?
            const col = this.querySelector('input[name^="Color"]:checked');
            if (!col) return;
            const selColor = col.value.trim();

            // b) gather every size for that color
            const variants = product.variants.filter(v => v.options[0] === selColor);
            const allSizes = [...new Set(variants.map(v => v.options[1]))];

            // c) what size did they have checked?
            const sizeIn = this.querySelector('input[name^="Size"]:checked');
            const oldSize = sizeIn?.value.trim();

            // d) if that old size isn’t one of the real ones…
            if (oldSize && !allSizes.includes(oldSize)) {
              // uncheck it
              sizeIn.checked = false;
              // pick the last (largest) existing size
              const fallback = allSizes[allSizes.length - 1];
              const radio = this.querySelector(
                `input[type="radio"][name^="Size"][value="${fallback}"]`
              );
              if (radio) radio.checked = true;
            }

            // e) rerun to catch the new valid variant
            requestAnimationFrame(() => this.onVariantChange(event));
          });
          return;
        }

        const variant = JSON.parse(raw);
        this.currentVariant = variant;



        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);

        const fp = document.querySelector(
          `fulfillment-picker[section-id="${this.sectionId}"]`
        );
        if (fp && variant?.id) {
          // this will fetch+render the wrapper and then inject props into the new form
          fp.setAttribute('variant-id', variant.id);
        
          // **and now force the UI logic into the fresh form**:
          fp._updateUI();
        }

        // —— Your frenzy snippet ——
        if (themeVarId !== variant.id) {
          themeVarId = variant.id;
          variant_id_Frenzy = variant.id;
          product_id_Frenzy = variant.featured_image?.product_id;
          frenzyReconmmadationCall();
        }

        // ─── NEW: Always update media first ───────────────────────
        this.updateMedia();

        // 2) Sold-out variant → “Sold out”
        if (!variant.available) {
          // ensure no pickup styling
          document
            .getElementById(`product-form-${this.sectionId}`)
            ?.querySelector('[name="add"]')
            ?.classList.remove('pickup-only');

          const soldOutText = window.variantStrings.soldOut || 'Sold out';
          this.toggleAddButton(
            true,       // disable
            soldOutText,// “Sold out”
            false       // no .pickup-only
          );
          document
            .getElementById(`price-${this.sectionId}`)
            ?.classList.add('visibility-hidden');
          return;
        }

        // 3) In-stock variant → shipping vs. pickup
        //this.checkShippingAvailability(variant.id);




        // —— Final Sale badge when on sale ——
        if (variant.compare_at_price != null && variant.compare_at_price !== 0) {
          const priceSaleElement = document.querySelector('.final__sale_flag');
          if (priceSaleElement) {
            const newDiv = document.createElement('div');
            newDiv.classList.add('warning-text', 'p-1', 'px-3');
            newDiv.innerHTML = `<p class="m-0">Final Sale</p>`;
            priceSaleElement.appendChild(newDiv);
          }
        }



        // 7) Reset any sliders (optional)
        const slider = document.querySelector('slider-component');
        if (slider?.resetSlider) slider.resetSlider();
      })
      .catch(console.error);
  }


  applySaleDots() {
    // 1) Grab the variant JSON script
    const script = this.querySelector('script[data-selected-variant]');
    if (!script) return;
  
    // 2) Bail if it’s literally "null" or empty
    const raw = script.textContent.trim();
    if (!raw || raw === 'null') return;
  
    // 3) Parse safely
    let selectedVariant;
    try {
      selectedVariant = JSON.parse(raw);
    } catch {
      return;
    }
  
    // 4) Pull out the selected color (for your size-dot filter later)
    const selColor = selectedVariant.option1;
    if (!selColor) return;
  
    // 5) Use cached JSON to iterate
    this.ensureProductJson().then(product => {
      // ─── 5a) Color-swatch sale-dots ─────────────────────────
      this.querySelectorAll('input[type="radio"][name^="Color"]').forEach(colorInput => {
        const colorValue = colorInput.value.trim();
        // is there *any* variant of this color on sale?
        const hasSale = product.variants.some(v =>
          v.option1 === colorValue &&
          v.compare_at_price != null &&
          v.compare_at_price !== 0
        );
        const label = this.querySelector(`label[for="${colorInput.id}"]`);
        if (!label) return;
  
        const dot = label.querySelector('.small--dot');
        if (hasSale) {
          if (!dot) {
            const span = document.createElement('span');
            span.className = 'small--dot';
            label.appendChild(span);
          }
        } else if (dot) {
          dot.remove();
        }
      });
  
      // ─── 5b) Your existing size-sale-dot logic ───────────────
      product.variants
        .filter(v => v.option1 === selColor)
        .forEach(variant => {
          // find the matching size input
          let input = this.querySelector(
            `input[type="radio"][data-option-value-id="${variant.id}"]`
          );
          if (!input) {
            input = this.querySelector(
              `input[type="radio"][value="${variant.option2}"]`
            );
          }
          if (!input) return;
  
          const label = this.querySelector(`label[for="${input.id}"]`);
          if (!label) return;
  
          // sale-dot logic on sizes
          const dot = label.querySelector('.small--dot');
          if (variant.compare_at_price != null && variant.compare_at_price !== 0) {
            if (!dot) {
              const span = document.createElement('span');
              span.className = 'small--dot';
              label.appendChild(span);
            }
          } else if (dot) {
            dot.remove();
          }
        });
    });
  }


  updateMedia() {
    // ───────────────────────────────────────────────────────────────
    // Grab & hide the slider container so we never paint mid-update
    // ───────────────────────────────────────────────────────────────
    const container = document.querySelector('.product__media-list');
    if (container) container.style.visibility = 'hidden';

    // ───────────────────────────────────────────────────────────────
    // Bail if we don't yet have a selected variant
    // ───────────────────────────────────────────────────────────────
    if (!this.currentVariant) {
      if (container) container.style.visibility = '';
      return;
    }

    // ───────────────────────────────────────────────────────────────
    // 1) Reorder featured_media to the front, only if it exists
    // ───────────────────────────────────────────────────────────────
    const featuredMedia = this.currentVariant.featured_media;
    const sectionId = this.dataset.section;

    if (featuredMedia) {
      const featuredId = featuredMedia.id;
      const lookup = `${sectionId}-${featuredId}`;
      const newMedia = document.querySelector(`[data-media-id="${lookup}"]`);

      if (newMedia) {
        const parent = newMedia.parentElement;
        if (parent.firstElementChild !== newMedia) {
          // Move in the modal
          const modalContent = document.querySelector(
            `#ProductModal-${sectionId} .product-media-modal__content`
          );
          if (modalContent) {
            const newMediaModal = modalContent.querySelector(
              `[data-media-id="${featuredId}"]`
            );
            if (newMediaModal) modalContent.prepend(newMediaModal);
          }

          // Move in the thumbnail list
          parent.prepend(newMedia);

          // Prevent sticky-header flash & scroll into view
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (this.stickyHeader)
            this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
          /* removed
          parent
            .querySelector('li.product__media-item')
            .scrollIntoView({ behavior: 'smooth' });
            */
        }
      }
    }

    // ───────────────────────────────────────────────────────────────
    // 2) Single-pass show/hide: featured OR matches the color slug
    // ───────────────────────────────────────────────────────────────
    const checked = this.querySelector('input[type="radio"]:checked');
    if (!checked) {
      if (container) container.style.visibility = '';
      return;
    }

    const target = checked.value
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-');

    const featuredLookup = featuredMedia
      ? `${sectionId}-${featuredMedia.id}`
      : null;

    document.querySelectorAll('.product__media-item').forEach(item => {
      const isFeatured = featuredLookup === item.dataset.mediaId;

      const thumb = item.querySelector('.image-zoom');
      const slug = thumb?.dataset.color
        ? thumb.dataset.color.trim().toLowerCase().replace(/\s+/g, '-')
        : '';

      const shouldShow = isFeatured || slug === target;
      item.classList.toggle('d-none', !shouldShow);
    });

    // ───────────────────────────────────────────────────────────────
    // 3) Re-show the container now that everything is in its final state
    // ───────────────────────────────────────────────────────────────
    if (container) container.style.visibility = '';

  }



  toggleAddButton(disable = false, text = '', modifyClass = true) {
    const form = document.getElementById(`product-form-${this.sectionId}`);
    const btn = form?.querySelector('[name="add"]');
    if (!btn) return;

    // 1) disable or enable
    if (disable) {
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.removeAttribute('disabled');
    }

    // 2) set whatever text you passed (or fallback)
    btn.textContent = text || window.variantStrings.addToCart;

    // 3) toggle pickup-only styling ONLY when you asked for it
    if (modifyClass) {
      btn.classList.toggle('pickup-only', text === 'Pickup Only');
    }
  }

  setUnavailable() {
    // disable + “Sold out”
    this.toggleAddButton(
      true,                       // disable
      window.variantStrings.unavailable, // “Sold out” text
      false                       // do NOT add .pickup-only
    );

    // hide the price
    const price = document.getElementById(`price-${this.sectionId}`);
    if (price) price.classList.add('visibility-hidden');
  }
}

// ─── Register element ────────────────────────────────────────────────
if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.onVariantChange(); // initial run
  }

  updateOptions() {
    console.log('🔧 VariantRadios.updateOptions');

    // Log every size input’s name
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      console.log(`  radio name="${input.name}" value="${input.value}"`);
    });

    // 1️⃣ Pick the selected color via name starts-with
    const selectedColorInput = this.querySelector(
      'input[type="radio"][name^="Color"]:checked'
    );
    console.log('  selectedColorInput:', selectedColorInput);
    const selectedColor = selectedColorInput?.value;
    if (!selectedColor) return;

    // 2️⃣ Fetch full product JSON
    fetch(`${this.dataset.url}.js`)
      .then(r => r.json())
      .then(product => {
        const possible = product.variants.filter(v => v.option1 === selectedColor);
        console.log('  possible variants for', selectedColor, possible);

        // 3️⃣ Update every Size radio by name starts-with “Size”
        this.querySelectorAll('input[type="radio"][name^="Size"]').forEach(input => {
          const match = possible.find(v => v.option2 === input.value);
          console.log(`    size="${input.value}" match:`, match);

          if (!match) {
            input.disabled = true;
            input.classList.add('unavailable');
          } else {
            input.disabled = !match.available;
            input.classList.toggle('unavailable', !match.available);
          }

          // sale-dot logic...
          const label = this.querySelector(`label[for="${input.id}"]`);
          const dot = label?.querySelector('.small--dot');
          if (match && match.compare_at_price) {
            if (!dot) {
              const span = document.createElement('span');
              span.className = 'small--dot';
              label.appendChild(span);
            }
          } else if (dot) {
            dot.remove();
          }
        });

        // 4️⃣ Show/hide pills
        this.querySelectorAll('.opt-title').forEach(el => {
          const sizeVal = el.getAttribute('data-val');
          const exists = possible.some(v => v.option2 === sizeVal);
          console.log(`    pill "${sizeVal}" → ${exists ? 'show' : 'hide'}`);
          el.style.display = exists ? '' : 'none';
        });
      })
      .catch(console.error);
  }
}

customElements.define('variant-radios', VariantRadios);
const bannercloser = document.getElementById('bannercloser')
const banner = document.getElementById('shopify-section-announcement-bar')

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function checkCookie() {
  if (getCookie('banner')) {
    banner.classList.add('disabled');
  } else {
    banner.classList.remove('disabled');
  }
}
checkCookie()


if (bannercloser != null) {
  bannercloser.addEventListener('click', () => {
    setTimeout(function () {
      banner.classList.remove('disabled');
    }, 1 * 24 * 60 * 60 * 1000)
    var d = new Date();
    d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
    var expires = "; expires=" + d.toGMTString();
    document.cookie = "banner=1" + expires + "; path=/";
    banner.classList.add('disabled');
  })
}
